import React from "react";

export default function WizardStepper({ steps, currentStepId, onStepClick }) {
  const currentIndex = steps.findIndex((s) => s.id === currentStepId);
  const isClickable = typeof onStepClick === "function";

  return (
    <ol
      className="mb-5 flex gap-2 overflow-x-auto rounded-2xl border border-zinc-300 bg-white p-2.5 shadow-sm"
      aria-label="Wizard steps"
    >
      {steps.map((step, index) => {
        const isActive = step.id === currentStepId;
        const isDone = currentIndex > index;

        return (
          <li
            key={step.id}
            className={[
              "min-w-[170px] flex-shrink-0 rounded-xl border px-3 py-2.5 text-sm transition-all duration-150",
              isClickable ? "cursor-pointer" : "cursor-default",
              isActive
                ? "border-zinc-900 bg-zinc-900 text-white shadow-sm"
                : isDone
                  ? "border-red-200 bg-red-50 text-red-700"
                  : "border-zinc-200 bg-zinc-50 text-zinc-700 hover:border-zinc-300 hover:bg-zinc-100",
            ].join(" ")}
            aria-current={isActive ? "step" : undefined}
            onClick={isClickable ? () => onStepClick(step.id) : undefined}
            role={isClickable ? "button" : undefined}
            tabIndex={isClickable ? 0 : undefined}
            onKeyDown={
              isClickable
                ? (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      onStepClick(step.id);
                    }
                  }
                : undefined
            }
          >
            <div className="flex items-center gap-2">
              <span
                className={[
                  "inline-flex h-6 w-6 items-center justify-center rounded-full border text-[11px] font-semibold",
                  isActive
                    ? "border-white/40 bg-white/10 text-white"
                    : isDone
                      ? "border-red-300 bg-white text-red-700"
                      : "border-zinc-300 bg-white text-zinc-500",
                ].join(" ")}
              >
                {isDone ? "OK" : index + 1}
              </span>
              <span className="truncate font-medium">{step.label}</span>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
